import type { ReactNode } from 'react';
import { Skeleton, EmptyState } from '@xcentral/ui';
import { useClientTiers } from './ClientTiersProvider';

/**
 * #12629 (CPT-2) — route guard for it-admin routes. Reads the caller's tier from
 * GET /api/v1/client-it/me (via useClientTiers), not the ID token.
 */
export function TierGuard({ requiredTier, children }: { requiredTier: string; children: ReactNode }) {
  const { loading, hasTier } = useClientTiers();

  if (loading) return <Skeleton lines={6} />;

  if (!hasTier(requiredTier)) {
    return (
      <EmptyState
        title="Access restricted"
        description="This area is for Client Administrators. If you need access, ask your account's Client Administrator or contact Conscierra."
      />
    );
  }

  return <>{children}</>;
}
